import { wrapActions, wrapSelector } from 'store/utils';

import { getAnalyticsParams } from './selectors';
import * as actions from './actions';

export const useAnalyticsActions = wrapActions({ ...actions });

export const useAnalyticsParams = wrapSelector(getAnalyticsParams);
